import * as tsx from 'vue-tsx-support';

import { JtnUiBtn, JtnUiTypography } from '@jtnews/jtn-ui';

import { StoreMixin } from '../../mixins';
import { BaseBlockFunctionalityMixin } from '../../mixins/base-block-functionality.mixin';

import styles from './send-opinion-block.scss?module';

// eslint-disable-next-line @typescript-eslint/naming-convention
const SendOpinionModal = () =>
  import(/* webpackChunkName: "send-opinion-modal" */ '@jtnews/layout/modals').then(
    m => m.SendOpinionModal
  );

// eslint-disable-next-line @typescript-eslint/naming-convention
const AuthAndRegisterModal = () =>
  import(/* webpackChunkName: "auth-and-register-modal" */ '@jtnews/layout/modals').then(
    m => m.AuthAndRegisterModal
  );

interface Events {
  onMounted: void;
  onOpenedModal: void;
  onShowed: void;
}

type ComponentData = {
  isSendOpinionModalOpened: false;
  isShowOpinionModalRendered: false;
  isAuthModalOpen: boolean;
  isAuthModalRendered: boolean;
};

export default tsx
  .componentFactoryOf<Events>()
  .mixin(StoreMixin)
  .mixin(BaseBlockFunctionalityMixin)
  .create({
    name: 'SendOpinionBlock',
    props: {
      isUserAuth: {
        type: Boolean,
        required: true
      },
      reachGoalBlockType: {
        type: String,
        default: ''
      }
    },
    data(): ComponentData {
      return {
        isSendOpinionModalOpened: false,
        isShowOpinionModalRendered: false,
        isAuthModalOpen: false,
        isAuthModalRendered: false
      };
    },
    computed: {
      sendOpinionModalParams() {
        return {
          reachGoalBlockType: this.reachGoalBlockType || this.getblockType()
        };
      }
    },
    mounted() {
      this.$emit('mounted');
    },
    methods: {
      onVisibleBlock() {
        this.$emit('showed');
      },
      openModal() {
        if (this.isUserAuth) {
          this.isSendOpinionModalOpened = true;
          this.isShowOpinionModalRendered = true;
        } else {
          this.isAuthModalRendered = true;
          this.isAuthModalOpen = true;
        }

        this.$emit('openedModal');
      }
    },
    render() {
      return (
        <div
          v-observe-visibility={this.obsHalfOptions}
          class={styles.sendOpinionBlock}
          onBtnClicked={() => this.openModal()}
        >
          <JtnUiTypography
            class={styles.content}
            tag="div"
            type="font-second-news-txt"
            linkType="link-blue"
          >
            {this.$slots.default}
          </JtnUiTypography>
          <JtnUiBtn class={styles.btn} onClick={() => this.openModal()}>
            Написать
          </JtnUiBtn>
          {this.isShowOpinionModalRendered && (
            <SendOpinionModal
              vModel={this.isSendOpinionModalOpened}
              params={this.feedbackToEditorsModalParams}
            />
          )}
          {this.isAuthModalRendered && (
            <AuthAndRegisterModal vModel={this.isAuthModalOpen} />
          )}
        </div>
      );
    }
  });
